import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

interface Payload {
  latLng: uui.domain.LatLng
}

/**
 * Search places on the map
 *
 * @private
 */
export const reverseGeocode = createAsyncThunk<
  // Return type of the payload creator
  uui.domain.client.Location,
  // First argument to the payload creator
  Payload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('ui/reverseGeocode', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/ui/reverseGeocode', {
      category: 'rpc',
      type: 'rpc/ui/reverseGeocode',
      params: payload,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }

    return result.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {reverseGeocode}`,
      { tags: ['rpc', 'ui', 'reverseGeocode'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Reverse geocode failed`,
      error,
    })
  }
})
